export function dollarsToCents(amount) {
    const negative = amount < 0;
    const [dollars, fraction = '00'] = Math.abs(amount).toFixed(2).split('.');
    const cents = Number(dollars) * 100 + Number(fraction);
    return negative ? -cents : cents;
}
//# sourceMappingURL=dollarsToCents.js.map